import React from 'react';
import { formatBps, formatNumber } from '../lib/routerMonitoringFormatters';

const Card = ({ label, value }) => (
  <div className="rounded-lg border border-slate-800 bg-slate-900/70 p-3">
    <p className="text-[11px] uppercase tracking-[0.12em] text-slate-400">{label}</p>
    <p className="mt-1 text-lg font-semibold text-cyan-200">{value}</p>
  </div>
);

const RouterTrafficSummaryCards = ({ summary }) => (
  <div className="grid gap-3 md:grid-cols-2 xl:grid-cols-4">
    <Card label="Total In" value={formatBps(summary?.total_in_bps)} />
    <Card label="Total Out" value={formatBps(summary?.total_out_bps)} />
    <Card label="Interface Monitored" value={formatNumber(summary?.monitored_interface_count)} />
    <Card label="PPP Aktif" value={formatNumber(summary?.active_ppp_sessions)} />
  </div>
);

export default RouterTrafficSummaryCards;
